import { PapiDeviation } from '@wix/da-papi-types';
import { useRef, useEffect } from 'react';

export function useDeviationChangedCallback(
  deviation: PapiDeviation | undefined,
  callback: (deviation: PapiDeviation) => void
) {
  const previousDeviationId = useRef<number>(undefined);
  const currentDeviationId = deviation && deviation.deviationId;

  useEffect(() => {
    if (deviation && currentDeviationId !== previousDeviationId.current) {
      callback(deviation);
    }

    previousDeviationId.current = currentDeviationId;
  }, [currentDeviationId, callback, deviation]);
}
